import React, { Component } from 'react';
import LoadingSpinner from '../common/LoadingSpinner.js';
import Table from './Table.js';

class Logs extends Component {
  constructor(props) {
    super(props)
    this.state = {
      logs: [],
      loading: true,
    }
  }

  componentDidMount = () => {
    this.getLogs();
  }

  getLogs = () => {
    fetch('/api/log', {
      method: "GET",
      credentials: "same-origin"
    }).then(r =>  r.json().then(data => ({res: r, body: data})))
    .then(obj => {
      if(!obj.res.ok) throw Error(obj.res.statusText);
      else{
        this.setState({logs: obj.body});
      }
    })
    .catch(function(error) {
      console.log(error);
    })
    .then(() => this.setState({loading: false}))
  }

  render = () => {
    if (this.state.loading)
      return <LoadingSpinner />

    return (
      <div>
        <h2 className="form-title">Logs</h2>
        <div className="row">
          <Table data={this.state.logs} />
        </div>
      </div>
    )
  }
}

export default Logs;


// WEBPACK FOOTER //
// ./src/Components/Logs/Logs.js